import { HeadingPhrases } from './HeadingPhrases'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/ui/icon'
import { SHOPIFY_APP_STORE_URL } from '@/config/public-links'

interface CTASectionProps {
  readonly answersHref: string
}

/** Repeat the install entry, with the free guide as the reading alternative. */
export function CTASection({ answersHref }: CTASectionProps) {
  const { t } = useTranslation()

  return (
    <section
      aria-labelledby="final-cta-title"
      className="lp-closing py-20 sm:py-24"
    >
      <div className="mx-auto w-full max-w-6xl px-6 text-center lg:px-10">
        <h2
          id="final-cta-title"
          className="mx-auto max-w-[32rem] text-balance text-3xl font-semibold tracking-[-0.025em] sm:text-4xl"
          style={{ color: 'var(--lp-ink)' }}
        >
          <HeadingPhrases text={t('landing:cta_final.title')} />
        </h2>
        <p
          className="mx-auto mt-4 max-w-[33rem] text-pretty text-lg leading-relaxed"
          style={{ color: 'var(--lp-body)' }}
        >
          {t('landing:cta_final.subtitle')}
        </p>

        <div className="mt-9 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <a
            href={SHOPIFY_APP_STORE_URL}
            className="lp-button group"
          >
            {t('landing:nav.install')}
            <Icon
              name="nav.arrowRight"
              size="sm"
              className="transition-transform duration-200 group-hover:translate-x-1"
              aria-hidden
            />
          </a>
          <a
            href={answersHref}
            className="lp-cta-ghost inline-flex h-12 w-full items-center sm:w-auto justify-center whitespace-nowrap rounded-md border px-6 text-base font-semibold transition-colors"
            style={{
              borderColor: 'var(--lp-rule-strong)',
              color: 'var(--lp-ink)',
            }}
          >
            {t('landing:nav.guide')}
          </a>
        </div>
      </div>
    </section>
  )
}
